<template>
    <CFooter :fixed="false">
        <div>
            <a href="https://www.leadgrease.com/privacy-policy/">Privacy</a>
            <a class="ml-1 pl-1 border-left" href="https://www.leadgrease.com/terms-conditions/">Terms</a>
            <a class="ml-1 pl-1 border-left" href="https://www.leadgrease.com/cookies/">Cookies</a>
        </div>
        <div class="ml-auto">
            <a target="_blank">Leadgrease</a>
            <span class="ml-1">{{ new Date().getFullYear() }}</span>
        </div>
        <div class="ml-auto">
            <span
                class="mr-1"
                target="_blank"
                style="font-size: 0.9em; color: gray; width: 72%"
                >pre-v{{ version }}</span
            >
        </div>
    </CFooter>
</template>

<script>
export default {
    name: "footer",
    data() {
        return {
            version: process.env.VUE_APP_VERSION,
        };
    },
};
</script>
